import * as React from 'react';

function ManageUser(props) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={26} height={26} viewBox='0 0 24 24' {...props}>
      <g id='Group_75' data-name='Group 75' transform='translate(-725 228)'>
        <rect
          id='Rectangle_19'
          data-name='Rectangle 19'
          width={24}
          height={24}
          transform='translate(725 -228)'
          fill='#fff'
        />
        <g id='Group_70' data-name='Group 70' transform='translate(726 -226)'>
          <path
            id='Path_26'
            data-name='Path 26'
            d='M17.7,6.475a.147.147,0,0,1,0-.041,2.51,2.51,0,0,0-.463-.675l-3.1-3.073A2.346,2.346,0,0,0,12.484,2H6.76A1.76,1.76,0,0,0,5,3.76v12.9a1.76,1.76,0,0,0,1.76,1.76h9.385a1.76,1.76,0,0,0,1.76-1.76V7.42A2.346,2.346,0,0,0,17.7,6.475ZM13.8,4,15.9,6.106H14.385a.587.587,0,0,1-.587-.587Zm2.933,12.663a.587.587,0,0,1-.587.587H6.76a.587.587,0,0,1-.587-.587V3.76a.587.587,0,0,1,.587-.587h5.865V5.519a1.76,1.76,0,0,0,1.76,1.76h2.346a1.138,1.138,0,0,1,0,.141Z'
            transform='translate(0 0)'
            fill='#003ec4'
          />
          <path
            id='Path_27'
            data-name='Path 27'
            d='M20.346,13h-1.76a.587.587,0,1,0,0,1.173h1.76a.587.587,0,0,0,0-1.173Z'
            transform='translate(-5.375 -4.548)'
            fill='#003ec4'
          />
          <path
            id='Path_28'
            data-name='Path 28'
            d='M16.625,18H9.587a.587.587,0,0,0,0,1.173h7.038a.587.587,0,0,0,0-1.173Z'
            transform='translate(-1.654 -6.615)'
            fill='#003ec4'
          />
          <path
            id='Path_29'
            data-name='Path 29'
            d='M16.625,22H9.587a.587.587,0,0,0,0,1.173h7.038a.587.587,0,0,0,0-1.173Z'
            transform='translate(-1.654 -8.269)'
            fill='#003ec4'
          />
          <path
            id='Path_30'
            data-name='Path 30'
            d='M9.587,12.692a.587.587,0,0,0,.587-.587,1.238,1.238,0,0,1,.5-.375,1.173,1.173,0,0,0,.493-.24.956.956,0,0,0,.182,0,1.015,1.015,0,0,0,.188,0,1.173,1.173,0,0,0,.5.24,1.314,1.314,0,0,1,.487.364.587.587,0,0,0,1.167.012c0-.727-.762-1.2-1.132-1.372a2.487,2.487,0,0,0,.252-1.267A1.525,1.525,0,0,0,11.346,8,1.525,1.525,0,0,0,9.88,9.466a2.487,2.487,0,0,0,.252,1.267c-.37.2-1.132.645-1.132,1.372A.587.587,0,0,0,9.587,12.692Zm1.76-3.519a.375.375,0,0,1,.293.293c0,.44,0,.645-.27.9h-.023c-.258-.258-.27-.463-.27-.9A.375.375,0,0,1,11.346,9.173Z'
            transform='translate(-1.654 -2.481)'
            fill='#003ec4'
          />
        </g>
      </g>
    </svg>
  );
}
export default ManageUser;
